window.USER_CAN_TOUCH = false;
window.addEventListener('touchstart', function onFirstTouch() {
  window.USER_CAN_TOUCH = true;
  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);


class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    this.cartNotification.setActiveElement(document.activeElement);
    
    const submitButton = this.querySelector('[type="submit"]');

    var buttonParentEl = submitButton.closest('.product__info-container');
 
    var isVariant = false;
      
    if(buttonParentEl.querySelector('[name="options[Size]"]') || buttonParentEl.querySelector('[name="options[Title]"]') || buttonParentEl.querySelector('[name="options[Material]"]') || buttonParentEl.querySelector('[name="options[Style]"]') || buttonParentEl.querySelector('[name="options[Version]"]')) {
      [].forEach.call(buttonParentEl.querySelectorAll('.select__select'), function(e) {
        if(e.value == 'Select Size' || e.value == 'Select an Option' || e.value == 'Select Material' || e.value == 'Select Style' || e.value == 'Select Version') {
          isVariant = true;
        }
      });
    }

    if(document.querySelector(".bookarc-for-macbook-select")) {
      if(document.querySelector(".bookarc-for-macbook-select").value == "Select Size") {
        isVariant = true;
      }
    }

    if(document.querySelector(".hirise-3-wireless-select")) {
      if(document.querySelector(".hirise-3-wireless-select").value == "Select Version") {
        isVariant = true;
      }
    }
    
    if(document.querySelector(".timeporter-select")) {
      if(document.querySelector(".timeporter-select").value == "Select Package") {
        isVariant = true;
      }
    }
    

    if(buttonParentEl.querySelector('[name="options[Color]"]')) {
      var inputElements = buttonParentEl.getElementsByClassName('product_swatch_radio');
      var checkedValue ='';

      for(var i=0; inputElements[i]; ++i){
        if(inputElements[i].checked){
          checkedValue = inputElements[i].value;
          isVariant = false;
          break;
        } else {

          var newItem2 = document.createElement("div");

          newItem2.className = 'error-msg__text2';
          newItem2.innerText = 'Please select a color';

          if(!buttonParentEl.querySelector('.error-msg__text2')) {
            buttonParentEl.querySelector('.product_swatch').prepend(newItem2); 
          }

          isVariant = true;
        }
      }

      if(document.querySelector(".bookarc-for-macbook-select")) {
        if(document.querySelector(".bookarc-for-macbook-select").value == "Select Size") {
          isVariant = true;
        }
      }

      
      if(document.querySelector(".hirise-3-wireless-select")) {
        if(document.querySelector(".hirise-3-wireless-select").value == "Select Version") {
          isVariant = true;
        }
      }

      if(document.querySelector(".timeporter-select")) {
        if(document.querySelector(".timeporter-select").value == "Select Package") {
          isVariant = true;
        }
      }
    }

    
    if(isVariant == false) {
      
      if(document.querySelector(".bookarc-for-macbook-select")) {
        document.querySelector(".bookarc-for-macbook-select").classList.remove('error-msg');
      }

      if(document.querySelector(".hirise-3-wireless-select")) {
        document.querySelector(".hirise-3-wireless-select").classList.remove('error-msg');
      }

      if(document.querySelector(".timeporter-select")) {
        document.querySelector(".timeporter-select").classList.remove('error-msg');
      }
      
      if(document.querySelector('[name="options[Size]"]')) {
        document.querySelector('[name="options[Size]"]').classList.remove('error-msg');
      }
      
      if(document.querySelector('[name="options[Title]"]')) {
        document.querySelector('[name="options[Title]"]').classList.remove('error-msg');
      }

      if(document.querySelector('[name="options[Material]"]')) {
        document.querySelector('[name="options[Material]"]').classList.remove('error-msg');
      }
      
      if(document.querySelector('[name="options[Style]"]')) {
        document.querySelector('[name="options[Style]"]').classList.remove('error-msg');
      }

      if(document.querySelector('[name="options[Version]"]')) {
        document.querySelector('[name="options[Version]"]').classList.remove('error-msg');
      }

      if(document.querySelector('.error-msg__text')) {
        document.querySelector('.error-msg__text').remove();
      }

      if(document.querySelector('.error-msg__text2')) {
        document.querySelector('.error-msg__text2').remove();
      }

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      
      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        //         this.cartNotification.renderContents(parsedState);

        var cartContents = fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {

          // Add PlugBug Slim product for HiRise 3 Wireless Charging Stand

          if(document.querySelector('.hirise-3-wireless-select')) {
            if(document.querySelector('.hirise-3-wireless-select').value == "HiRise 3 + PlugBug Slim") {
              var addProductData2 = {
                'id': 39343003762745,
                'quantity': 1
              };
              
              fetch('/cart/add.js', {
                body: JSON.stringify(addProductData2),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
                },
                method: 'POST'
              }).then(function(response) {
                Shopify.updateQuickCart(cart);
                return response.json();
              }).then(function(json) {
                console.log(json)
              }).catch(function(err) {
                console.error(err)
              });
  
            }
          }
            
          // End PlugBug Slim product for HiRise 3 Wireless Charging Stand
          

          // Add PlugBug Slim product for HiRise 3 Wireless Charging Stand
          
          // if(parsedState.product_title == "HiRise 3 Wireless Charging Stand") {
          //   if (parsedState.title.includes("PlugBug Slim")) {
          //     var addProductData = {
          //       'id': 39343003762745,
          //       'quantity': 1
          //     };
          //     fetch('/cart/add.js', {
          //       body: JSON.stringify(addProductData),
          //       credentials: 'same-origin',
          //       headers: {
          //         'Content-Type': 'application/json',
          //         'X-Requested-With':'xmlhttprequest'
          //       },
          //       method: 'POST'
          //     }).then(function(response) {
          //       Shopify.updateQuickCart(cart);
          //       return response.json();
          //     }).then(function(json) {
          //       console.log(json)
          //     }).catch(function(err) {
          //       console.error(err)
          //     });
          //   }
          // }
          
        // End PlugBug Slim product for HiRise 3 Wireless Charging Stand
          

        // Add additional product for BookArc
      
          if(document.querySelector(".bookarc-for-macbook-select")) {
            var selectedValue = document.querySelector(".bookarc-for-macbook-select").value,
                selectedColor = "",
                silverVariantID = 40804278665273,
                spaceGreyVariantID = 40804278698041,
                checkboxes = document.getElementsByClassName('product_swatch_radio'),
                anyChecked = false;
                
            for (let i = 0; i < checkboxes.length; i++) {
              if (checkboxes[i].checked) {
                anyChecked = true;
                break;
              }
            }
            
            if (anyChecked) {
              selectedColor = document.querySelector(".product_swatch_radio:checked").value;
            } else {
              selectedColor = "Silver";
            }
            
            function addAdditionalProduct(selectedVariantID) {
              var addData = {
                'id':selectedVariantID,
                'quantity':1
              };
            
              fetch('/cart/add.js', {
                body: JSON.stringify(addData),
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With':'xmlhttprequest'
                },
                method: 'POST'
              }).then(function(response) {
                Shopify.updateQuickCart(cart);
                return response.json();
              }).then(function(json) {
                console.log(json)
              }).catch(function(err) {
                console.error(err)
              });
            }
        
            if(selectedValue == "BookArc for MacBook Air") {
              if(selectedColor == "Silver") {
                addAdditionalProduct(silverVariantID);
                  
              } else {
                addAdditionalProduct(spaceGreyVariantID);
              }
            }
          }
          
          // End of Add additional product for BookArc

          var checkout_now_btn = document.querySelector('.checkout_now_btn');
          if( cart.item_count > 0 ) {    
            if(checkout_now_btn) {
              var checkout_now_btn_countEl =	checkout_now_btn.querySelector('.site-header__cart-count span');
              if(checkout_now_btn_countEl) {
                checkout_now_btn_countEl.innerHTML = cart.item_count;
              }
              checkout_now_btn.classList.remove('hide');
              var navBuyNowEl = document.querySelector('.nav-buy-now');
              if(navBuyNowEl) {
                navBuyNowEl.classList.add('hide');
              }
            }
            
            // document.querySelector('.additional-checkout-buttons-wrap').classList.remove('hidden');
            
          } else {
            if(checkout_now_btn) {
              checkout_now_btn.classList.add('hide');
              var navBuyNowEl = document.querySelector('.nav-buy-now');
              if(navBuyNowEl) {
                navBuyNowEl.classList.remove('hide');
              }

            }
            
            // document.querySelector('.additional-checkout-buttons-wrap').classList.add('hidden');
          }
          Shopify.updateQuickCart(cart);
        });

        var cart_drawer = document.querySelector('#cart_drawer');
        var pushy_body_wrapper = document.querySelector('.pushy_body_wrapper');

        window.setTimeout(function(){

          if(pushy_body_wrapper) {
            pushy_body_wrapper.classList.add('open_drawer');
          }

          if(cart_drawer) {
            cart_drawer.classList.add('active');
          }
        }, 100);

        if(!USER_CAN_TOUCH) {
          var drawer_timeout =  window.setTimeout(function(){


            if(pushy_body_wrapper) {
              pushy_body_wrapper.classList.remove('open_drawer');
            }
            if(cart_drawer) {
              cart_drawer.classList.remove('active');
            }        
          }, 5100);
          if(cart_drawer) {
            cart_drawer.addEventListener('mouseenter', function() {
              clearTimeout(drawer_timeout);
            });
          }

        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
    });
  } else {

    if(document.querySelector(".bookarc-for-macbook-select")) {
      
      document.querySelector('.bookarc-for-macbook-select').classList.add('error-msg');
      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a size';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('.bookarc-for-macbook-select').parentElement.prepend(newItem); 
      }
    }

    if(document.querySelector(".hirise-3-wireless-select")) {
      
      document.querySelector('.hirise-3-wireless-select').classList.add('error-msg');
      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a version';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('.hirise-3-wireless-select').parentElement.prepend(newItem); 
      }
    }

    
    if(document.querySelector(".timeporter-select")) {
      
      document.querySelector('.timeporter-select').classList.add('error-msg');
      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a package';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('.timeporter-select').parentElement.prepend(newItem); 
      }
    }

    if(document.querySelector('[name="options[Size]"]')) {
      document.querySelector('[name="options[Size]"]').classList.add('error-msg');

      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a size';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('[name="options[Size]"]').parentElement.prepend(newItem); 
      }
    }
    
    if(document.querySelector('[name="options[Title]"]')) {

      document.querySelector('[name="options[Title]"]').classList.add('error-msg');

      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select an option';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('[name="options[Title]"]').parentElement.prepend(newItem); 
      }
    }
    
    if(document.querySelector('[name="options[Material]"]')) {

      document.querySelector('[name="options[Material]"]').classList.add('error-msg');

      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a material';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('[name="options[Material]"]').parentElement.prepend(newItem); 
      }
    }
      
    if(document.querySelector('[name="options[Style]"]')) {

      document.querySelector('[name="options[Style]"]').classList.add('error-msg');

      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a style';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('[name="options[Style]"]').parentElement.prepend(newItem); 
      }
    }

    if(document.querySelector('[name="options[Version]"]')) {

      document.querySelector('[name="options[Version]"]').classList.add('error-msg');

      var newItem = document.createElement("div");

      newItem.className = 'error-msg__text';
      newItem.innerText = 'Please select a version';

      if(!document.querySelector('.error-msg__text')) {
        document.querySelector('[name="options[Version]"]').parentElement.prepend(newItem); 
      }
    }

    }
  }
}

customElements.define('product-form', ProductForm);

var productMediaArr = document.querySelectorAll('.product__media-wrapper.enable_image_zoom .product__media-item .product__media');
if(productMediaArr.length) {

  productMediaArr.forEach(function (productMedia,index) {
    productMedia.addEventListener('mousemove', function(e) {
      var zoomer = e.currentTarget,
          bg = zoomer.dataset.bg;

      e.offsetX = offsetX = e.offsetX;
      e.offsetY = offsetY = e.offsetY;
      x = offsetX/zoomer.offsetWidth*100
      y = offsetY/zoomer.offsetHeight*100
      zoomer.style.background = "url('" + bg + "')";
      zoomer.style.setProperty('background-position-x', x + '%');
      zoomer.style.setProperty('background-position-y', y + '%');
    });

    productMedia.addEventListener('mouseleave', function(e) {
      var zoomer = e.currentTarget,
          bg = zoomer.dataset.bg;

      zoomer.style.background = "none";
    });
  });
}


// Select for BookArc product 

if(document.querySelector(".bookarc-for-macbook-select")) {

  const selectElement = document.querySelector(".bookarc-for-macbook-select");
  
  selectElement.addEventListener("change", function() {
    const selectedOption = selectElement.value;

    const swatchElements = document.querySelectorAll('.swatch-element');

    swatchElements.forEach(element => {
      if (element.classList.contains('variant-unavailable')) {
        element.classList.remove('variant-unavailable');
      }
    });
  
    if(selectedOption == 'BookArc for MacBook Air') {
      const liElements = document.querySelectorAll('.bookArc-insert-options li[data-variant-title]'),
      divElements = document.querySelectorAll('.swatch-element[data-value]');
      
      for (const li of liElements) {
          const variantTitle = li.getAttribute('data-variant-title');
          for (const div of divElements) {
              const dataValue = div.getAttribute('data-value');
              if (variantTitle === dataValue) {
                if(li.dataset.variantAvailable == 'false') {
                  div.classList.add('variant-unavailable');
                }
              }
          }
      }
    }
  });
}


// Packaging options for TimePorter product

if(document.querySelector(".timeporter-select")) {
  let selectElement = document.querySelector(".timeporter-select"), 
      initialPrice = '';
  
  selectElement.addEventListener("change", function() {
    let selectedOption = selectElement.value,
        selectedIndex = selectElement.selectedIndex,
        selectedCurrentOption = selectElement.options[selectedIndex],
        dataPrice = selectedCurrentOption.getAttribute('data-price');

    document.querySelector('.price__regular span.money').innerText = '$ ' + dataPrice;
    
    if(selectedOption == "Single Pack") {
      document.querySelector('.product-form__quantity input').value = '1';
    }
    if(selectedOption == "Buy 2, Save $5") {
      document.querySelector('.product-form__quantity input').value = '2';
    }
    if(selectedOption == "Buy 3, Save $10") {
      document.querySelector('.product-form__quantity input').value = '3';
    }
    if(selectedOption == "Buy 4, Save $20") {
      document.querySelector('.product-form__quantity input').value = '4';
    }
  });
}

// Updated additional product price for HiRise 3 + PlugBug Slim

if(document.querySelector(".hirise-3-wireless-select")) {
  let selectElement = document.querySelector(".hirise-3-wireless-select");
  
  selectElement.addEventListener("change", function() {
    let selectedOption = selectElement.value,
        selectedIndex = selectElement.selectedIndex,
        selectedCurrentOption = selectElement.options[selectedIndex],
        dataPrice = selectedCurrentOption.getAttribute('data-price');

    document.querySelector('.price__regular span.money').innerText = '$ ' + dataPrice;
  });
}
